import React from 'react';
import './EventRow.css';

const EventRow = (props) => {
    return (
        <div className="evr-row">
            <div className="evr-info">
                <p className="evr-title">{props.title}</p>
                <p className="evr-date">{props.date}</p>
            </div>
            <span className={`evr-badge evr-badge--${props.badgeType}`}>{props.badge}</span>
        </div>
    );
};

export default EventRow;